import { forwardRef, type Ref, type SVGProps } from "react";
const IconPetsFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M21.91 16.38a6.86 6.86 0 0 0-11.82 0v.05l-2.4 4.44a5.66 5.66 0 0 0 .81 6.54 4.75 4.75 0 0 0 5.41 1.21 4.86 4.86 0 0 1 4.18 0 4.75 4.75 0 0 0 5.41-1.21 5.66 5.66 0 0 0 .81-6.54zM11.71 12c2 0 3.54-2.14 3.42-4.69C15 4.83 13.36 2.91 11.4 3S8 5.21 8.14 7.69 9.85 12 11.71 12m-3.62 1.41C7.5 11.51 5.78 10 4 10.55s-2.41 2.55-1.76 4.66 2.39 3.38 4.08 2.87 2.42-2.56 1.77-4.67M28 10.55c-1.77-.55-3.49.95-4.08 2.86-.65 2.11.13 4.16 1.77 4.67s3.43-.75 4.08-2.87-.13-4.15-1.77-4.66M20.14 12c2.1.1 3.61-2 3.73-4.3C24 5 22.41 3.1 20.61 3c-2.08-.11-3.61 2-3.73 4.3-.14 2.7 1.46 4.6 3.26 4.7" />
  </svg>
);
const ForwardRef = forwardRef(IconPetsFilledSVG);
ForwardRef.displayName = "IconPetsFilled";
export { ForwardRef as IconPetsFilled };
